import React from 'react';
import UserHome from '../UserRoutes/UserHomepage/UserHomePage.component.jsx';
import UserSettings from '../UserRoutes/UserSettings/UserSettingsHome.component.jsx';
import AllCoursesPage from '../UserRoutes/UserHomepage/UserAllCourses.component.jsx';
import UserPurchaseHistory from '../UserRoutes/PurchaseHistory/UserPurchaseHistory.component.jsx';
import CertificatesPage from '../UserRoutes/UserCertificates/Certificates.component.jsx';
import UserDetailsBasePage from '../UserDetails/UserDetails.component.jsx';

export const userRoutes = [
  { path: '', element: <UserHome /> },
  { path: 'settings/:id', element: <UserSettings /> },
  { path: 'all-courses', element: <AllCoursesPage /> },
  { path: 'purchase-history', element: <UserPurchaseHistory /> },
  { path: 'certificates', element: <CertificatesPage /> },
  { path: 'profile/:id', element: <UserDetailsBasePage /> },
];
